import React from 'react';
import { ClipboardCheck, Email } from '@good/icons';
import { Box, Paper, Stack, ThemeIcon, Skeleton } from '@good/ui/core';

export const CreateAgreementLinkModalBodySkeleton = () => {
  return (
    <Stack>
      <Paper withBorder p='md'>
        <Stack>
          <ThemeIcon variant='default' size='lg'>
            <Email />
          </ThemeIcon>
          <Stack gap={4}>
            <Skeleton h={16} w={180} />
            <Skeleton h={16} w={300} />
          </Stack>
          <Box>
            <Skeleton h={36} w={150} />
          </Box>
        </Stack>
      </Paper>
      <Paper withBorder p='md'>
        <Stack>
          <ThemeIcon variant='default' size='lg'>
            <ClipboardCheck />
          </ThemeIcon>
          <Stack gap={4}>
            <Skeleton h={16} w={180} />
            <Skeleton h={16} w={300} />
          </Stack>
          <Skeleton h={36} />
        </Stack>
      </Paper>
    </Stack>
  );
};
